import { Injectable } from '@angular/core';

@Injectable()
export class DynamicOnboardingConfigurationService {

  constructor() { }

  
  //WARNING: Order of initialState.steps items should match order of data items
  //         Order of items reflects rendered steps
  getStepsConfiguration(guidance: any, initialState: any, roles: string[]): { cardType: string, bucket?: string, key?: string, text?: string, folds: number }[] {
    // console.log(guidance);
    initialState.steps = [];
    const excludeGDPR = !!guidance.data && guidance.data.step; // && guidance.data.step !== 'onboarding-gdpr';
    if (!excludeGDPR)
      initialState.steps.push({ key: 'gdpr', icon: 'fa fa-file-text', title: 'Privacy Policy' });
    if (roles.includes('buyer-admin')) {
      // initialState.steps.push(
      //   { key: 'welcome', icon: 'fa fa-list-alt', title: 'onboarding.welcome.step.title' },
      //   { key: 'adminInduction', icon: 'fa fa-file-image', title: 'onboarding.account.administrator.slot.one.step.title' },
      //   { key: 'adminInduction2', icon: 'fa fa-file-image', title: 'onboarding.account.administrator.slot.two.step.title' },
      //   { key: 'adminInduction3', icon: 'fa fa-file-image', title: 'onboarding.account.administrator.slot.three.step.title' },
      //   { key: 'adminInduction4', icon: 'fa fa-file-image', title: 'onboarding.account.administrator.slot.four.step.title' }
      // );
    } else if (roles.includes('buyer-read') && !roles.includes('solar-partner')) {
      initialState.steps.push(
        { key: 'buyerInduction', icon: 'fa fa-list-alt', title: 'onboarding.buyer.step.title' },
        { key: 'buyerInduction2', icon: 'fa fa-list-alt', title: 'onboarding.buyer.step.two.title' },
        { key: 'buyerInduction3', icon: 'fa fa-list-alt', title: 'onboarding.buyer.step.three.title' }//,
        // { key: 'buyerInduction4', icon: 'fa fa-list-alt', title: 'onboarding.buyer.step.four.title' },
        // { key: 'buyerInduction5', icon: 'fa fa-list-alt', title: 'onboarding.buyer.step.five.title' }
      );
    } else if (roles.includes('solar-partner') && !roles.includes('buyer-read')) {
      initialState.steps.push(
        { key: 'deliveryManagerInduction', icon: 'fa fa-list-alt', title: 'onboarding.delivery.manager.step.title' },
        { key: 'deliveryManagerInduction2', icon: 'fa fa-list-alt', title: 'onboarding.delivery.manager.step.two.title' },
        { key: 'deliveryManagerInduction3', icon: 'fa fa-list-alt', title: 'onboarding.delivery.manager.step.three.title' },
        { key: 'deliveryManagerInduction4', icon: 'fa fa-list-alt', title: 'onboarding.delivery.manager.step.four.title' },

      );
    } else if (roles.includes('solar-partner') && roles.includes('buyer-read')) {
      initialState.steps.push(
        { key: 'deliveryManagerbuyerInduction', icon: 'fa fa-list-alt', title: 'onboarding.deliveryManagerbuyer.step.title' },
        { key: 'deliveryManagerbuyerInduction2', icon: 'fa fa-list-alt', title: 'onboarding.deliveryManagerbuyer.step.two.title' },
        { key: 'deliveryManagerbuyerInduction3', icon: 'fa fa-list-alt', title: 'onboarding.deliveryManagerbuyer.step.three.title' },
        { key: 'deliveryManagerbuyerInduction4', icon: 'fa fa-list-alt', title: 'onboarding.deliveryManagerbuyer.step.four.title' },
        { key: 'deliveryManagerbuyerInduction5', icon: 'fa fa-list-alt', title: 'onboarding.deliveryManagerbuyer.step.five.title' }
      );
    }
    let data: { cardType: string, image?: string, text?: string, folds: number, title: string }[] = [];
    if (!excludeGDPR)
      data.push({ cardType: 'gdpr', folds: 1, title: 'onboarding.gdpr.title' });
    if (roles.includes('buyer-admin')) {
      // data.push(...this.getAdminConf());
    } else if (roles.includes('buyer-read') && !roles.includes('solar-partner')) {
      data.push(...this.getBuyerConf());
    } else if (roles.includes('solar-partner') && !roles.includes('buyer-read')) {
      data.push(...this.getDeliveryConf());
    } else if (roles.includes('solar-partner') && roles.includes('buyer-read')) {
      data.push(...this.getDeliveryBuyerConf());
    }
    return data;
  }

  getAdminConf() {
    return [
      {
        cardType: 'welcome',
        text: 'onboarding.welcome.text',
        image: 'onboarding.welcome.imageURL',
        folds: 4,
        title: 'onboarding.welcome.title'
      },
      // { cardType: 'overview', folds: 1, title: 'onboarding.overview.title' },
      // {
      //   cardType: 'branding',
      //   image: 'onboarding.invite.branding.imageURL',
      //   text: 'onboarding.cover-logo.text',
      //   folds: 3,
      //   title: 'onboarding.branding.title'
      // },
      // {
      //   cardType: 'employees',
      //   image: 'onboarding.invite.employees.imageURL',
      //   text: 'onboarding.invite.employees.instructions',
      //   folds: 3,
      //   title: 'onboarding.employees.invite.title'
      // },
      {
        cardType: 'adminInduction',
        text: 'onboarding.account.administrator.next.steps.one.text',
        image: 'onboarding.account.administrator.next.steps.one.imageURL',
        folds: 4,
        title: 'onboarding.account.administrator.next.steps.one.title'
      },
      {
        cardType: 'adminInduction2',
        text: 'onboarding.account.administrator.next.steps.two.text',
        image: 'onboarding.account.administrator.next.steps.two.imageURL',
        folds: 4,
        title: 'onboarding.account.administrator.next.steps.two.title'
      },
      {
        cardType: 'adminInduction3',
        text: 'onboarding.account.administrator.next.steps.three.text',
        image: 'onboarding.account.administrator.next.steps.three.imageURL',
        folds: 4,
        title: 'onboarding.account.administrator.next.steps.three.title'
      },
      {
        cardType: 'adminInduction4',
        text: 'onboarding.account.administrator.next.steps.four.text',
        image: 'onboarding.account.administrator.next.steps.four.imageURL',
        folds: 4,
        title: 'onboarding.account.administrator.next.steps.four.title'
      }];
  }

  getDeliveryConf() {
    return [
      {
        cardType: 'deliveryManagerInduction',
        text: 'onboarding.delivery.manager.text',
        image: 'onboarding.delivery.manager.imageURL',
        folds: 4,
        title: 'onboarding.delivery.manager.title'
      }, {
        cardType: 'deliveryManagerInduction2',
        text: 'onboarding.delivery.manager.two.text',
        image: 'onboarding.delivery.manager.two.imageURL',
        folds: 4,
        title: 'onboarding.delivery.manager.two.title'
      }, {
        cardType: 'deliveryManagerInduction3',
        text: 'onboarding.delivery.manager.three.text',
        image: 'onboarding.delivery.manager.three.imageURL',
        folds: 4,
        title: 'onboarding.delivery.manager.three.title'
      }, {
        cardType: 'deliveryManagerInduction4',
        text: 'onboarding.delivery.manager.four.text',
        image: 'onboarding.delivery.manager.four.imageURL',
        folds: 4,
        title: 'onboarding.delivery.manager.four.title'
      }
    ];
  }
  getBuyerConf() {
    return [{
      cardType: 'buyerInduction',
      text: 'onboarding.buyerInduction.text',
      image: 'onboarding.buyerInduction.imageURL',
      folds: 4,
      title: 'onboarding.buyerInduction.title'
    },
    {
      cardType: 'buyerInduction2',
      text: 'onboarding.buyerInduction.two.text',
      image: 'onboarding.buyerInduction.two.imageURL',
      folds: 4,
      title: 'onboarding.buyerInduction.two.title'
    },
    {
      cardType: 'buyerInduction3',
      text: 'onboarding.buyerInduction.three.text',
      image: 'onboarding.buyerInduction.three.imageURL',
      folds: 4,
      title: 'onboarding.buyerInduction.three.title'
    }//,
      // {
      //   cardType: 'buyerInduction4',
      //   text: 'onboarding.buyerInduction.four.text',
      //   image: 'onboarding.buyerInduction.four.imageURL',
      //   folds: 4,
      //   title: 'onboarding.buyerInduction.four.title'
      // },
      // {
      //   cardType: 'buyerInduction5',
      //   text: 'onboarding.buyerInduction.five.text',
      //   image: 'onboarding.buyerInduction.five.imageURL',
      //   folds: 4,
      //   title: 'onboarding.buyerInduction.five.title'
      // }
    ];
  }
  getDeliveryBuyerConf() {
    return [{
      cardType: 'deliveryManagerbuyerInduction',
      text: 'onboarding.deliveryManagerbuyerInduction.text',
      image: 'onboarding.deliveryManagerbuyerInduction.imageURL',
      folds: 4,
      title: 'onboarding.deliveryManagerbuyerInduction.title'
    },
    {
      cardType: 'deliveryManagerbuyerInduction2',
      text: 'onboarding.deliveryManagerbuyerInduction.two.text',
      image: 'onboarding.deliveryManagerbuyerInduction.two.imageURL',
      folds: 4,
      title: 'onboarding.deliveryManagerbuyerInduction.two.title'
    },
    {
      cardType: 'deliveryManagerbuyerInduction3',
      text: 'onboarding.deliveryManagerbuyerInduction.three.text',
      image: 'onboarding.deliveryManagerbuyerInduction.three.imageURL',
      folds: 4,
      title: 'onboarding.deliveryManagerbuyerInduction.three.title'
    },
    {
      cardType: 'deliveryManagerbuyerInduction4',
      text: 'onboarding.deliveryManagerbuyerInduction.four.text',
      image: 'onboarding.deliveryManagerbuyerInduction.four.imageURL',
      folds: 4,
      title: 'onboarding.deliveryManagerbuyerInduction.four.title'
    },
    {
      cardType: 'deliveryManagerbuyerInduction5',
      text: 'onboarding.deliveryManagerbuyerInduction.five.text',
      image: 'onboarding.deliveryManagerbuyerInduction.five.imageURL',
      folds: 4,
      title: 'onboarding.deliveryManagerbuyerInduction.five.title'
    }]
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/dynamic-onboarding/dynamic-onboarding-configuration.service.ts